import { render, staticRenderFns } from "./ecoTourism.vue?vue&type=template&id=49765e75&"
var script = {}
import style0 from "./ecoTourism.vue?vue&type=style&index=0&id=49765e75&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports